"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.opexToastStatusSelector = exports.areOpexsLoadingSelector = exports.opexsSelector = void 0;
const opexsSelector = (state) => {
    return state.otherCosts.opexs;
};
exports.opexsSelector = opexsSelector;
const areOpexsLoadingSelector = (state) => {
    return state.otherCosts.areOpexsLoading;
};
exports.areOpexsLoadingSelector = areOpexsLoadingSelector;
const opexToastStatusSelector = (state) => {
    return state.otherCosts.opexToastStatus;
};
exports.opexToastStatusSelector = opexToastStatusSelector;
